import React from 'react';
import './TeamPage.scss';

interface TeamPageProps {
  menuOpen: boolean;
}

const TeamPage: React.FC<TeamPageProps> = ({ menuOpen }) => {
  return (
    <div className={`team-page ${menuOpen ? 'menu-open' : ''}`}>
      <div className="team-page__hero">
        <div className="team-page__content">
          <h1 className="team-page__title">ABOUT US</h1>
          
          <div className="team-page__text-content">
            <div className="team-page__intro">
              <p>
                Stage Door Weddings was founded with a passion for capturing the authentic moments that make your wedding day uniquely yours. 
                We believe every couple has a story worth telling, and we're here to preserve those memories in cinematic detail.
              </p>
              <p>
                With years of experience in wedding videography and a background in filmmaking, we bring a creative eye and professional 
                approach to every wedding we film. Our style is natural, unobtrusive, and focused on the genuine emotions of your day.
              </p>
            </div>

            <div className="team-page__approach">
              <h2>Our Approach</h2>
              <p>
                We work closely with each couple to understand their vision and ensure their film reflects their personality. 
                From intimate ceremonies to grand celebrations, we capture every moment with care and creativity.
              </p>
              <p>
                Using professional cinema cameras and audio equipment, we create films that look and sound beautiful. 
                Our editing process is meticulous, ensuring every frame tells part of your story.
              </p>
            </div>
          </div>

          <div className="team-page__values">
            <h2>What We Believe</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>Authenticity</h3>
                <p>Real moments, genuine emotions — we don't stage or direct. Your day unfolds naturally.</p>
              </div>
              
              <div className="value-item">
                <h3>Quality</h3>
                <p>Professional equipment, expert editing, and attention to every detail.</p>
              </div>
              
              <div className="value-item">
                <h3>Creativity</h3>
                <p>Every wedding is unique. Your film should be too.</p>
              </div>
              
              <div className="value-item">
                <h3>Service</h3>
                <p>From first contact to final delivery, we're here to make the process seamless.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamPage;
